export default "__VITE_ASSET__CEgCL87k__"